export default __webpack_public_path__ + "static/media/after@2x.30acfa24.png";